(function(){
  'use strict';

  function fireChange(input){
    if(!input)return;
    input.dispatchEvent(new Event('change',{bubbles:true}));
  }

  function setHidden(el,hidden){
    if(!el)return;
    if(hidden)el.setAttribute('hidden','');
    else el.removeAttribute('hidden');
  }

  function findProductScope(root){
    return root.closest('product-info, .product-info, .product__info-container, .product__info-wrapper, [data-product-information], [data-product-section], section')||root.parentElement;
  }

  function hideLegacyPurchaseUI(root){
    var scope=findProductScope(root);
    if(!scope)return;
    ['[class*="appstle"]','[id*="appstle"]','.quantity-breaks','.quantity-break','[class*="quantity-break"]','[data-quantity-breaks]','[data-quantity-break]'].forEach(function(selector){
      scope.querySelectorAll(selector).forEach(function(node){
        if(node.contains(root)||root.contains(node))return;
        node.style.setProperty('display','none','important');
        node.setAttribute('data-melt-hidden-legacy','true');
      });
    });

    var nodes=Array.prototype.slice.call(scope.querySelectorAll('div,fieldset,section,ul'));
    var packNode=null;
    nodes.forEach(function(node){
      if(packNode||node.contains(root)||root.contains(node))return;
      var text=(node.innerText||'').replace(/\s+/g,' ').toUpperCase();
      if(text.indexOf('STARTER')>-1&&text.indexOf('RITUAL')>-1&&text.indexOf('TRANSFORM')>-1&&text.indexOf('1 PACK')>-1&&text.indexOf('3 PACK')>-1){
        var kids=Array.prototype.slice.call(node.children||[]);
        packNode=kids.find(function(child){
          var t=(child.innerText||'').replace(/\s+/g,' ').toUpperCase();
          return t.indexOf('STARTER')>-1&&t.indexOf('RITUAL')>-1&&t.indexOf('TRANSFORM')>-1;
        })||node;
      }
    });
    if(packNode){
      packNode.style.setProperty('display','none','important');
      packNode.setAttribute('data-melt-hidden-pack-selector','true');
    }

    Array.prototype.slice.call(scope.querySelectorAll('button,label,div')).forEach(function(node){
      if(node.contains(root)||root.contains(node))return;
      var text=(node.textContent||'').replace(/\s+/g,' ').trim().toUpperCase();
      if(text==='CHOOSE YOUR PLAN'||text==='SUBSCRIPTION DETAIL'){
        var target=node.closest('div,fieldset,section')||node;
        if(target&&!target.contains(root))target.style.setProperty('display','none','important');
      }
    });
  }

  function injectOneTimeStyles(){
    if(document.getElementById('melt-one-time-v5-styles'))return;
    var style=document.createElement('style');
    style.id='melt-one-time-v5-styles';
    style.textContent='\
.melt-sub-v4__one-time-box{margin-top:10px;border:1px solid var(--mv4-line,#ded5ce);border-radius:16px;overflow:hidden;background:rgba(255,253,250,.64);transition:border-color .2s ease,box-shadow .2s ease}\
.melt-sub-v4__one-time-box.is-selected{border-color:#9b8a81;background:#fffdfa;box-shadow:0 8px 22px rgba(43,25,21,.05)}\
.melt-sub-v4__one-time-box>.melt-sub-v4__one-time{margin:0;border:0;border-radius:0;background:transparent}\
.melt-sub-v4__one-time-box.is-selected>.melt-sub-v4__one-time{background:#fffdfa}\
.melt-sub-v4__one-time-panel{padding:0 14px 14px;background:#fffdfa;border-top:1px solid #eee4de;animation:mv4OneReveal .22s ease}\
.melt-sub-v4__one-time-panel[hidden]{display:none!important}\
@keyframes mv4OneReveal{from{opacity:.2;transform:translateY(-3px)}to{opacity:1;transform:none}}\
.melt-sub-v4__one-time-kicker{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:13px 2px 10px}\
.melt-sub-v4__one-time-kicker strong{font-size:9px;font-weight:850;letter-spacing:.13em;color:var(--mv4-cran,#81131d)}\
.melt-sub-v4__one-time-kicker span{font-size:8px;color:var(--mv4-muted,#6f6660)}\
.melt-sub-v4__one-time-options{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}\
.melt-sub-v4__one-option{position:relative;min-height:92px;padding:12px;border:1px solid #e4d8d0;border-radius:12px;background:#fff;cursor:pointer;text-align:left;transition:border-color .18s ease,box-shadow .18s ease,transform .18s ease}\
.melt-sub-v4__one-option:hover{transform:translateY(-1px);border-color:#cdbdb4}\
.melt-sub-v4__one-option.is-selected{border:1.5px solid var(--mv4-cran,#81131d);box-shadow:0 7px 18px rgba(101,16,25,.08);background:#fffaf8}\
.melt-sub-v4__one-option-top{display:flex;align-items:center;justify-content:space-between;gap:7px}\
.melt-sub-v4__one-option-title{font-size:12px;font-weight:780;letter-spacing:-.02em}\
.melt-sub-v4__one-option-badge{padding:4px 6px;border-radius:999px;background:var(--mv4-gold-soft,#fbf0cf);color:#684714;font-size:6px;font-weight:900;letter-spacing:.06em;white-space:nowrap}\
.melt-sub-v4__one-option-meta{margin-top:4px;color:var(--mv4-muted,#6f6660);font-size:8px}\
.melt-sub-v4__one-option-bottom{display:flex;align-items:flex-end;justify-content:space-between;gap:7px;margin-top:11px}\
.melt-sub-v4__one-option-price{font-size:16px;font-weight:790;letter-spacing:-.035em}\
.melt-sub-v4__one-option-unit{color:#756a64;font-size:7px;text-align:right}\
.melt-sub-v4__one-option-dot{position:absolute;top:9px;right:9px;width:7px;height:7px;border:1px solid #a89a92;border-radius:50%;background:#fff}\
.melt-sub-v4__one-option.is-selected .melt-sub-v4__one-option-dot{border-color:var(--mv4-cran,#81131d);background:var(--mv4-cran,#81131d);box-shadow:inset 0 0 0 2px #fff}\
.melt-sub-v4__one-time.is-expanded .melt-sub-v4__radio>span{background:var(--mv4-cran,#81131d);transform:scale(1)}\
.melt-sub-v4__one-time.is-expanded .melt-sub-v4__radio{border-color:var(--mv4-cran,#81131d)}\
@media(max-width:680px){.melt-sub-v4__one-time-options{grid-template-columns:1fr}.melt-sub-v4__one-option{min-height:72px;display:grid;grid-template-columns:1fr auto;align-items:center;gap:6px 14px}.melt-sub-v4__one-option-top{grid-column:1}.melt-sub-v4__one-option-meta{grid-column:1;margin:0}.melt-sub-v4__one-option-bottom{grid-column:2;grid-row:1/3;display:flex;flex-direction:column;align-items:flex-end;justify-content:center;margin:0}.melt-sub-v4__one-option-dot{display:none}}';
    document.head.appendChild(style);
  }

  function parseMoney(text){
    var value=parseFloat(String(text||'').replace(/[^0-9.-]/g,''));
    return isNaN(value)?0:value;
  }

  function perTin(total,pack){
    if(!pack)return '';
    var n=parseMoney(total);
    if(!n)return '';
    return '$'+(n/pack).toFixed(2)+' / tin';
  }

  function buildOneTimeSelector(root,oneTime,tierCards){
    if(!oneTime||oneTime.closest('[data-melt-one-time-box]'))return oneTime?oneTime.closest('[data-melt-one-time-box]'):null;

    var wrapper=document.createElement('div');
    wrapper.className='melt-sub-v4__one-time-box';
    wrapper.setAttribute('data-melt-one-time-box','');
    oneTime.parentNode.insertBefore(wrapper,oneTime);
    wrapper.appendChild(oneTime);
    oneTime.setAttribute('aria-expanded','false');

    var summary=oneTime.querySelector('span:nth-child(2)');
    if(summary){
      var strong=summary.querySelector('strong');
      var small=summary.querySelector('small');
      if(strong)strong.textContent='One-time purchase';
      if(small)small.textContent='Choose 1, 2 or 3 tins · no subscription · no member extras';
    }

    var panel=document.createElement('div');
    panel.className='melt-sub-v4__one-time-panel';
    panel.setAttribute('data-melt-one-time-panel','');
    panel.hidden=true;
    panel.innerHTML='<div class="melt-sub-v4__one-time-kicker"><strong>CHOOSE YOUR SUPPLY</strong><span>BUY ONCE</span></div><div class="melt-sub-v4__one-time-options" role="radiogroup" aria-label="Choose one-time quantity"></div>';
    wrapper.appendChild(panel);

    var options=panel.querySelector('.melt-sub-v4__one-time-options');
    var map=[{days:'30',pack:1,label:'1 Pack',films:'30 oral films'},{days:'60',pack:2,label:'2 Packs',films:'60 oral films'},{days:'90',pack:3,label:'3 Packs',films:'90 oral films'}];
    map.forEach(function(item){
      var card=tierCards.find(function(c){return c.getAttribute('data-melt-tier')===item.days;});
      if(!card)return;
      var button=document.createElement('button');
      button.type='button';
      button.className='melt-sub-v4__one-option';
      button.setAttribute('data-melt-one-option',String(item.pack));
      button.setAttribute('data-variant-id',card.dataset.variantId||'');
      button.setAttribute('data-price-money',card.dataset.basePriceMoney||'');
      button.setAttribute('data-available',card.dataset.available||'true');
      button.setAttribute('aria-pressed','false');
      var badge=item.pack===3?'<span class="melt-sub-v4__one-option-badge">BEST ONE-TIME VALUE</span>':'';
      button.innerHTML='<span class="melt-sub-v4__one-option-dot" aria-hidden="true"></span><span class="melt-sub-v4__one-option-top"><span class="melt-sub-v4__one-option-title">'+item.label+'</span>'+badge+'</span><span class="melt-sub-v4__one-option-meta">'+item.films+'</span><span class="melt-sub-v4__one-option-bottom"><span class="melt-sub-v4__one-option-price">'+(card.dataset.basePriceMoney||'')+'</span><span class="melt-sub-v4__one-option-unit">'+perTin(card.dataset.basePriceMoney,item.pack)+'</span></span>';
      options.appendChild(button);
    });
    return wrapper;
  }

  function init(root){
    if(!root||root.dataset.meltInitialized==='true')return;
    root.dataset.meltInitialized='true';
    injectOneTimeStyles();
    hideLegacyPurchaseUI(root);

    var form=root.querySelector('form');
    var variantInput=root.querySelector('[data-melt-variant-input]');
    var planInput=root.querySelector('[data-melt-selling-plan-input]');
    var tierCards=Array.prototype.slice.call(root.querySelectorAll('[data-melt-tier]'));
    var oneTime=root.querySelector('[data-melt-one-time]');
    var oneBox=buildOneTimeSelector(root,oneTime,tierCards);
    var onePanel=oneBox?oneBox.querySelector('[data-melt-one-time-panel]'):null;
    var oneOptions=oneBox?Array.prototype.slice.call(oneBox.querySelectorAll('[data-melt-one-option]')):[];
    var cta=root.querySelector('[data-melt-submit]');
    var ctaLabel=root.querySelector('[data-melt-cta-label]');
    var ctaPrice=root.querySelector('[data-melt-cta-price]');
    var renewal=root.querySelector('[data-melt-renewal]');
    var currentMode='subscription',currentTier=null,currentOne='1';
    var cartError=root.querySelector('[data-melt-cart-error]');
    var isSubmitting=false;

    function numericId(value){
      var match=String(value||'').match(/(\d+)$/);
      return match?Number(match[1]):null;
    }

    function showCartError(message){
      if(!cartError)return;
      cartError.textContent=message||'';
      cartError.hidden=!message;
    }

    function setSubmitting(busy){
      isSubmitting=busy;
      if(!cta)return;
      cta.setAttribute('aria-busy',busy?'true':'false');
      if(busy)cta.disabled=true;
      else{
        var selected=currentMode==='subscription'?getCard(currentTier||root.dataset.defaultTier||'90'):getOne(currentOne||'1');
        cta.disabled=selected?selected.dataset.available==='false':false;
      }
    }

    async function addCurrentSelection(){
      if(isSubmitting)return;
      showCartError('');

      if(currentMode==='subscription'&&planInput&&!planInput.value){
        var fallback=getCard(currentTier||root.dataset.defaultTier||'90');
        if(fallback)updateSubscription(fallback);
      }

      var variantId=numericId(variantInput&&variantInput.value);
      if(!variantId){
        showCartError('Please choose a supply option.');
        return;
      }

      var mainItem={id:variantId,quantity:1};

      if(currentMode==='subscription'){
        var planId=numericId(planInput&&planInput.value);
        if(!planId){
          showCartError('This membership option is temporarily unavailable.');
          return;
        }
        mainItem.selling_plan=planId;
      }

      var cartDrawer=document.querySelector('cart-drawer');
      var sections=[];

      if(cartDrawer&&typeof cartDrawer.getSectionsToRender==='function'){
        sections=cartDrawer.getSectionsToRender().map(function(section){
          return section.id;
        });
      }

      var shopRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      var addUrl=(window.routes&&window.routes.cart_add_url)||(shopRoot+'cart/add.js');
      var cartUrl=(window.routes&&window.routes.cart_url)||(shopRoot+'cart');

      function payload(items){
        var body={items:items};

        if(sections.length){
          body.sections=sections;
          body.sections_url=window.location.pathname;
        }

        return body;
      }

      async function addItems(items){
        var response=await fetch(addUrl,{
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json',
            'X-Requested-With':'XMLHttpRequest'
          },
          body:JSON.stringify(payload(items))
        });

        var state=await response.json();

        if(!response.ok||state.status){
          throw new Error(
            state.description||
            state.message||
            'We could not add this selection to your cart.'
          );
        }

        return state;
      }

      try{
        setSubmitting(true);

        if(cartDrawer&&typeof cartDrawer.setActiveElement==='function'){
          try{
            cartDrawer.setActiveElement(cta);
          }catch(setActiveError){}
        }

        /*
         * Stable MELT cart path:
         * 1) add the qualifying membership first
         * 2) add each welcome item once
         * No polling, no auto-delete loop, no retry loop.
         */
        var finalState=await addItems([mainItem]);

        if(currentMode==='subscription'){
          var productId=numericId(root.dataset.productId);
          var productTitle=root.dataset.productTitle||'MELT';
          var config={
            8034355413049:{
              digital:50554611793977,
              gift1:46531896901689,
              gift2:45260290588729,
              gift2Label:'DREAM',
              protocol:'THE IGNITE PROTOCOL™'
            },
            8085515632697:{
              digital:50573036879929,
              gift1:46531896901689,
              gift2:45260276465721,
              gift2Label:'IGNITE',
              protocol:'THE DREAM PROTOCOL™'
            },
            8086924755001:{
              digital:50596714676281,
              gift1:46531896901689,
              gift2:45260290588729,
              gift2Label:'DREAM',
              protocol:'THE RELAX PROTOCOL™'
            },
            8085516386361:{
              digital:50597857722425,
              gift1:46531896901689,
              gift2:45260298649657,
              gift2Label:'RELAX',
              protocol:'THE ATTRACT PROTOCOL™'
            },
            8434515836985:{
              digital:50597896257593,
              gift1:46531896901689,
              gift2:46475887935545,
              gift2Label:'DEBLOAT',
              protocol:'THE TONE PROTOCOL™'
            },
            8434516000825:{
              digital:50598069010489,
              gift1:46531896901689,
              gift2:46475887706169,
              gift2Label:'TONE',
              protocol:'THE DEBLOAT PROTOCOL™'
            }
          }[productId]||{};

          var digitalGift=numericId(root.dataset.digitalGiftId)||config.digital||null;
          var gift1=numericId(root.dataset.gift1Id)||config.gift1||null;
          var gift2=numericId(root.dataset.gift2Id)||config.gift2||null;
          var gift1Label=root.dataset.gift1Label||'MELT PRIME';
          var gift2Label=root.dataset.gift2Label||config.gift2Label||'MELT COMPANION';
          var protocolLabel=root.dataset.protocolLabel||config.protocol||('THE '+productTitle+' PROTOCOL™');
          var giftsEnabled=String(root.dataset.giftsEnabled)==='true'||!!config.gift1;

          function giftProperties(type,label){
            var props={
              '_melt_subscription_tier':currentTier||'',
              '_melt_membership_product_id':String(productId||''),
              '_melt_membership_variant_id':String(variantId||''),
              '_melt_membership_product':productTitle
            };

            if(type==='protocol'){
              props._melt_subscriber_gift=label;
            }else{
              props._melt_welcome_gift=label;
            }

            return props;
          }

          if((currentTier==='60'||currentTier==='90')&&giftsEnabled&&gift1){
            finalState=await addItems([{
              id:gift1,
              quantity:1,
              properties:giftProperties('welcome',gift1Label)
            }]);
          }

          if(currentTier==='90'&&giftsEnabled&&gift2){
            finalState=await addItems([{
              id:gift2,
              quantity:1,
              properties:giftProperties('welcome',gift2Label)
            }]);
          }

          if(digitalGift){
            finalState=await addItems([{
              id:digitalGift,
              quantity:1,
              properties:giftProperties('protocol',protocolLabel)
            }]);
          }
        }

        async function renderCurrentCart(){
          var sectionState=finalState&&finalState.sections?finalState.sections:null;

          if(!sectionState||!sectionState['cart-drawer']){
            try{
              var refreshResponse=await fetch(
                cartUrl+'?sections=cart-drawer,cart-icon-bubble',
                {
                  headers:{
                    'Accept':'application/json',
                    'X-Requested-With':'XMLHttpRequest'
                  }
                }
              );

              if(refreshResponse.ok){
                sectionState=await refreshResponse.json();
              }
            }catch(refreshError){
              console.warn('[MELT] Fresh cart section fetch failed.',refreshError);
            }
          }

          if(!sectionState)return false;

          var parser=new DOMParser();
          var rendered=false;

          if(cartDrawer&&sectionState['cart-drawer']){
            try{
              var drawerDoc=parser.parseFromString(
                sectionState['cart-drawer'],
                'text/html'
              );

              var freshInner=drawerDoc.querySelector(
                '#CartDrawer .drawer__inner'
              );

              var currentInner=cartDrawer.querySelector(
                '#CartDrawer .drawer__inner'
              );

              if(freshInner&&currentInner){
                currentInner.replaceWith(freshInner);
                cartDrawer.classList.remove('is-empty');
                rendered=true;
              }
            }catch(drawerRefreshError){
              console.warn(
                '[MELT] Direct cart drawer refresh failed.',
                drawerRefreshError
              );
            }
          }

          if(sectionState['cart-icon-bubble']){
            try{
              var iconDoc=parser.parseFromString(
                sectionState['cart-icon-bubble'],
                'text/html'
              );

              var freshIcon=iconDoc.querySelector('#cart-icon-bubble');
              var currentIcon=document.getElementById('cart-icon-bubble');

              if(freshIcon&&currentIcon){
                currentIcon.replaceWith(freshIcon);
              }
            }catch(iconRefreshError){
              console.warn(
                '[MELT] Cart icon refresh skipped.',
                iconRefreshError
              );
            }
          }

          if(rendered&&cartDrawer&&typeof cartDrawer.open==='function'){
            try{
              cartDrawer.open(cta);
            }catch(openError){
              console.warn('[MELT] Cart drawer open skipped.',openError);
            }
          }

          return rendered;
        }

        var drawerRendered=await renderCurrentCart();

        if(!drawerRendered){
          if(window.Shopify&&window.Shopify.designMode){
            window.location.reload();
          }else{
            window.location.href=cartUrl;
          }
        }

      }catch(error){
        console.error('[MELT] Add to cart failed:',error);

        showCartError(
          error&&error.message
            ?error.message
            :'We could not add this selection to your cart. Please try again.'
        );
      }finally{
        setSubmitting(false);
      }
    }

    function getCard(days){return root.querySelector('[data-melt-tier="'+days+'"]');}
    function getOne(pack){return root.querySelector('[data-melt-one-option="'+pack+'"]');}

    function closeSubscription(){
      tierCards.forEach(function(card){
        card.classList.remove('is-selected','is-expanded');
        var button=card.querySelector('[data-melt-tier-button]');
        if(button)button.setAttribute('aria-pressed','false');
        setHidden(card.querySelector('[data-melt-expanded]'),true);
      });
    }

    function closeOneTime(){
      if(oneBox)oneBox.classList.remove('is-selected');
      if(oneTime){oneTime.classList.remove('is-expanded');oneTime.setAttribute('aria-pressed','false');oneTime.setAttribute('aria-expanded','false');}
      setHidden(onePanel,true);
    }

    function updateSubscription(card){
      if(!card)return;
      var available=card.dataset.available!=='false';
      if(variantInput){variantInput.value=card.dataset.variantId||'';fireChange(variantInput);}
      if(planInput){planInput.disabled=false;planInput.value=card.dataset.planId||'';fireChange(planInput);}
      if(cta)cta.disabled=!available;
      if(ctaLabel)ctaLabel.textContent=available?'START MY MELT MEMBERSHIP':'SOLD OUT';
      if(ctaPrice)ctaPrice.textContent=card.dataset.priceMoney||'';
      if(renewal)renewal.innerHTML='Renews at <strong>'+(card.dataset.priceMoney||'')+'</strong> '+String(card.dataset.cadence||'').toLowerCase()+'. Manage anytime.';
      root.dataset.purchaseType='subscription';
      root.dataset.selectedTier=card.getAttribute('data-melt-tier')||'';
    }

    function selectTier(days,scroll){
      var card=getCard(days);if(!card)return;
      currentMode='subscription';currentTier=days;
      closeSubscription();closeOneTime();
      card.classList.add('is-selected','is-expanded');
      var button=card.querySelector('[data-melt-tier-button]');
      if(button)button.setAttribute('aria-pressed','true');
      setHidden(card.querySelector('[data-melt-expanded]'),false);
      updateSubscription(card);
      if(scroll&&window.innerWidth<681)window.requestAnimationFrame(function(){card.scrollIntoView({behavior:'smooth',block:'nearest'});});
    }

    function updateOneTime(option){
      if(!option)return;
      currentMode='one-time';currentTier=null;currentOne=option.getAttribute('data-melt-one-option')||'1';
      oneOptions.forEach(function(btn){btn.classList.remove('is-selected');btn.setAttribute('aria-pressed','false');});
      option.classList.add('is-selected');option.setAttribute('aria-pressed','true');
      if(variantInput){variantInput.value=option.dataset.variantId||'';fireChange(variantInput);}
      if(planInput){planInput.value='';planInput.disabled=true;fireChange(planInput);}
      var available=option.dataset.available!=='false';
      if(cta)cta.disabled=!available;
      if(ctaLabel)ctaLabel.textContent=available?'ADD '+currentOne+(currentOne==='1'?' PACK':' PACKS')+' TO CART':'SOLD OUT';
      if(ctaPrice)ctaPrice.textContent=option.dataset.priceMoney||'';
      if(renewal)renewal.textContent='One-time purchase · no recurring delivery · no member extras.';
      var price=oneTime?oneTime.querySelector('b'):null;if(price)price.textContent=option.dataset.priceMoney||'';
      root.dataset.purchaseType='one-time';root.dataset.selectedTier='one-time-'+currentOne;
    }

    function selectOneTime(){
      if(!oneBox)return;
      closeSubscription();
      oneBox.classList.add('is-selected');
      if(oneTime){oneTime.classList.add('is-expanded');oneTime.setAttribute('aria-pressed','true');oneTime.setAttribute('aria-expanded','true');}
      setHidden(onePanel,false);
      updateOneTime(getOne(currentOne)||getOne('1'));
      if(window.innerWidth<681)window.requestAnimationFrame(function(){oneBox.scrollIntoView({behavior:'smooth',block:'nearest'});});
    }

    tierCards.forEach(function(card){
      var button=card.querySelector('[data-melt-tier-button]');
      if(button)button.addEventListener('click',function(){selectTier(card.getAttribute('data-melt-tier'),true);});
    });
    if(oneTime)oneTime.addEventListener('click',selectOneTime);
    oneOptions.forEach(function(option){option.addEventListener('click',function(e){e.stopPropagation();updateOneTime(option);});});

    if(form)form.addEventListener('submit',function(e){
      e.preventDefault();
      addCurrentSelection();
    });

    selectTier(root.dataset.defaultTier||'90',false);
    var observer=new MutationObserver(function(){hideLegacyPurchaseUI(root);});
    var scope=findProductScope(root);
    if(scope)observer.observe(scope,{childList:true,subtree:true});
  }

  function boot(){document.querySelectorAll('[data-melt-subscription-buybox]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
